import { useFormat } from '@ideavivat/vivat-2';
import { toCommaFormat } from '@/utils';

// const toDecimalFormat = (string: any) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
// const toDecimal = (string: any) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    // createdAt: {
    //   name: 'สร้างเมื่อ',
    //   width: '11rem',
    //   filter: (val: string) => useFormat.date(val).displayShortThaiDateTime(),
    //   class: 'text-left',
    // },
    // deliveryNumber: {
    //   name: 'เลขที่ DN',
    //   width: '6rem',
    //   class: 'text-left',
    // },
    type: {
      name: 'ประเภทสินค้า',
      width: '1fr',
    },
    amount: {
      name: 'ยอดรายรับ',
      width: '6rem',
      class: {
        cell: 'text-center',
        text: 'text-right',
      },
      filter: (val: string) => toCommaFormat(val, 2, 2),
    },
  },
};
